import { IsString } from "class-validator";

/**
 * Response contract for project business scope lookup.
 */
export class ProjectBusinessScopeDto {
  @IsString()
  businessScope!: string;

  constructor(businessScope: string) {
    this.businessScope = businessScope;
  }
}
